import { useHistory, useParams } from "react-router";
import { ApiLoadingSpinner, BreadCrumb, Header } from "@funcional/react-ui";
import {
  useRegistrationPolicy,
  useUpdateRegistrationPolicy,
} from "@pbm/registration-policies/hooks";
import { useCreateAuthenticationExternalApi } from "@pbm/registration-policies/hooks/useCreateAuthenticationExternalApi";
import { useFindAuthenticationExternalApi } from "@pbm/registration-policies/hooks/useFindAuthenticationExternalApi";
import RegistrationPolicyForm from "@pbm/registration-policies/components/RegistrationPolicyForm";
import { useState } from "react";
import { IGraphQLError } from "@common/contracts";

export default function EditRegistrationPolicyPage() {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  let { registrationPolicyId }: { registrationPolicyId: string } = useParams();

  const {
    status: fetchStatus,
    data: fetchData,
    error: fetchError,
  } = useRegistrationPolicy(registrationPolicyId);

  const {
    status: ExternalApiStatus,
    data: ExternalApiData,
    error: ExternalApiError,
  } = useFindAuthenticationExternalApi(Number(registrationPolicyId));

  const { isLoading, isSuccess, mutateAsync } = useUpdateRegistrationPolicy();
  const createAuthenticationExternalApi = useCreateAuthenticationExternalApi();

  const dataForm = {
    RegistrationPolicyCode: Number(registrationPolicyId),
    header: ExternalApiData?.authenticationExternalApi?.header,
    form: ExternalApiData?.authenticationExternalApi?.form,
    url: ExternalApiData?.authenticationExternalApi?.url,
    token: ExternalApiData?.authenticationExternalApi?.token,
    method: ExternalApiData?.authenticationExternalApi?.method,
    id: Number(registrationPolicyId),
    description: fetchData?.description,
    requiresRegistration: fetchData?.requiresRegistration,
    requiresPrescription: fetchData?.requiresPrescription,
    requiresContactInformation: fetchData?.requiresContactInformation,
    createdAt: fetchData?.createdAt,
    updatedAt: fetchData?.updatedAt,
    deletedAt: fetchData?.deletedAt,
    allowedOrigins: fetchData?.allowedOrigins,
    formFields: fetchData?.formFields,
    enabledApiExternal: fetchData?.enabledApiExternal,
  };

  if (dataForm.header === undefined) {
    dataForm.header = [{ key: "", value: "" }];
  }
  if (dataForm.form === undefined) {
    dataForm.form = [{ type: "", key: "", value: "" }];
  }

  const history = useHistory();

  const onSubmit = async (data: any) => {
    try {
      const formField = {
        description: data?.description,
        requiresRegistration: data?.requiresRegistration,
        requiresPrescription: data?.requiresPrescription,
        requiresContactInformation: data?.requiresContactInformation,
        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,
        deletedAt: data?.deletedAt,
        allowedOrigins: data?.allowedOrigins,
        formFields: data?.formFields,
        enabledApiExternal: data?.enabledApiExternal,
      };

      const updatedInput = Object.assign(
        {
          id: registrationPolicyId,
          // checkbox won't be sent, so I must inform the default values as false
          requiresRegistration: false,
          requiresPrescription: false,
          requiresContactInformation: false,
          enabledApiExternal: false,
        },
        formField
      );

      delete updatedInput.createdAt;
      delete updatedInput.updatedAt;
      delete updatedInput.deletedAt;
      console.log("data", data);
      await mutateAsync(updatedInput);

      const headerApi = {
        RegistrationPolicyCode: Number(registrationPolicyId),
        header: data?.header,
        form: data?.form,
        url: data?.url,
        token: data?.token,
        method: data?.method,
      };

      if (formField.enabledApiExternal === true) {
        await createAuthenticationExternalApi.mutateAsync(headerApi);
      }

      return history.push(`/pbm/registration-policies/${registrationPolicyId}`);
    } catch (error: any) {
      console.error(error);
      if (error.response.errors) {
        return setGraphQLErrors(error.response.errors || []);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header
        title="Editar Política Cadastral"
        backTo={`/pbm/registration-policies/${registrationPolicyId}`}
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            {
              path: "/pbm/registration-policies",
              label: "Políticas Cadastrais",
            },
            {
              path: `/pbm/registration-policies/${registrationPolicyId}`,
              label: registrationPolicyId,
            },
            { label: "Editar" },
          ]}
        />
      </Header>

      <div>
        {fetchStatus === "loading" ? (
          <ApiLoadingSpinner />
        ) : fetchStatus === "error" ? (
          <span>Erro: {JSON.stringify(fetchError)}</span>
        ) : dataForm ? (
          <RegistrationPolicyForm
            graphQLErrors={graphQLErrors}
            isLoading={isLoading || isSuccess}
            onSubmit={onSubmit}
            defaults={dataForm}
            authenticationExternalApi={dataForm}
          />
        ) : (
          <div>Registro não encontrado.</div>
        )}
      </div>
    </>
  );
}
